function edipart(state) {
	return state.edipart;
}
export default { edipart };